
define('text!features/overlayGameLauncher/stats/shop/shopViewSmall.html',[],function () { return '<div>\n    <span class="icon icon-24 icons-briefcase"></span>\n</div>\n';});

